export default {"src":"/_next/static/media/appstore.185417bb.svg","height":40,"width":120,"blurWidth":0,"blurHeight":0};